/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { switchMap } from 'rxjs/operators';

import { IpUserMiddlewaresService } from '../user-middleware-service/ip-middlewares.service';
import { UploadBottomSheetDialogComponent } from './upload-bottom-sheet-dialog/upload-bottom-sheet-dialog.component';
import { IpUserImageUploaderService } from './user-image-uploader.service';

/**
 * @internal
 */
export default class ImageUploader extends IpUserImageUploaderService {
  constructor(private matBottomSheet: MatBottomSheet, private userMiddlewaresService: IpUserMiddlewaresService) {
    super();
  }

  browse$() {
    return this.matBottomSheet
      .open(UploadBottomSheetDialogComponent, {
        ariaLabel: 'Browse media'
      })
      .afterDismissed()
      .pipe(switchMap(path => this.userMiddlewaresService.uploadImage(path)));
  }
}
